import React from "react";

type StackProps = {
  className?: string;
  children: React.ReactNode;
};

export const Stack: React.FC<StackProps> = ({ children, className }) => {
  return (
    <div className={`position-relative ${className ?? ""}`}>{children}</div>
  );
};

type PositionProps = {
  className?: string;
  children?: React.ReactNode;
  left?: number;
  top?: number;
  right?: number;
  bottom?: number;
};
export const Position: React.FC<PositionProps> = ({
  children,
  className,
  left,
  top,
  right,
  bottom,
}) => {
  let style: any = {};
  if (left !== undefined) {
    style = { ...style, left: `${left}px` };
  }
  if (top !== undefined) {
    style = { ...style, top: `${top}px` };
  }
  if (right !== undefined) {
    style = { ...style, right: `${right}px` };
  }
  if (bottom !== undefined) {
    style = { ...style, bottom: `${bottom}px` };
  }
  return (
    <div className={`position-absolute ${className ?? ""}`} style={style}>
      {children}
    </div>
  );
};
